import styles from '../../assets/styles/BusinessInsights/BusinessInsights.module.scss';
import { IoMdInformationCircle } from 'react-icons/io';
import { MimaText, Modal } from '../../components';
import React from 'react';

function AdditionalInfo({ closeModal, modalInfo, goToModalInfo }) {
	return (
		<Modal closeModal={closeModal}>
			<>
				{!modalInfo && (
					<div className={styles.modalTable}>
						<table>
							<tbody>
								<tr>
									<td>Average Income</td>
									<td>N300</td>
								</tr>

								<tr>
									<td>Average Sales Income</td>
									<td>N12.35</td>
								</tr>

								<tr>
									<td>Average Profit</td>
									<td>N180</td>
								</tr>

								<tr>
									<td>Average Sales Profit</td>
									<td>N10.00</td>
								</tr>

								<tr>
									<td>Average Expense</td>
									<td>N120</td>
								</tr>

								<tr>
									<td>Average Sales Expense</td>
									<td>N2.35</td>
								</tr>

								<tr>
									<td>Debt Owed</td>
									<td>-</td>
								</tr>

								<tr>
									<td>Best Performing Product</td>
									<td>Agbada</td>
								</tr>

								<tr>
									<td>Highest Expense</td>
									<td>Beads</td>
								</tr>
							</tbody>
						</table>
					</div>
				)}

				{modalInfo && (
					<div className={styles.terms}>
						<MimaText variant="subtitle" mb={2} align="center">
							Terms Explained
						</MimaText>
						<div>
							<span>Average Income</span> refers to Lorem ipsum dolor sit amet,
							consectetur adipiscing elit, <br /> <br />
							<span>Average Sales Income</span> refers to eiusmod tempor
							incididunt ut labore et dolore magna aliqua.
							<br /> <br />
							<span>Average Profit</span> refers to Ut enim ad minim veniam,
							quis nostrud exercitation ullamco <br /> <br />
							<span>Average Sales Profit</span> refers to laboris nisi ut
							aliquip ex ea commodo consequat. <br /> <br />
							<span>Average Expense</span> refers to Duis aute irure dolor in
							reprehenderit in voluptate velit esse cillum <br /> <br />
							<span>Average Sales Expense</span> refers to dolore eu fugiat
							nulla pariatur. Excepteur sint occaecat cupidatat <br /> <br />
							<span>Debt owed</span> refers to non proident, sunt in culpa qui
							officia deserunt mollit anim id est laborum <br /> <br />
							<span>Max Asset Financing</span> refers to dolore eu fugiat nulla
							pariatur. Excepteur sint occaecat cupidatat <br /> <br />
							<span>Best Performing Product</span> refers to dolore eu fugiat
							nulla pariatur. Excepteur sint occaecat <br /> <br />
							<span>Highest Expense</span> refers to dolore eu fugiat nulla
							pariatur. Excepteur sint occaecat cupidatat
						</div>
					</div>
				)}

				<div className={styles.modalInfo} onClick={goToModalInfo}>
					<IoMdInformationCircle />
				</div>
			</>
		</Modal>
	);
}

export default AdditionalInfo;
